import React from 'react';
import { motion } from 'framer-motion';

const Slide1Title = () => {
  return (
    <div className="w-full h-full min-h-[100svh] lg:min-h-0 bg-background flex flex-col lg:flex-row relative overflow-hidden">
      {/* Background Grid Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{ backgroundImage: 'linear-gradient(white 1px, transparent 1px), linear-gradient(90deg, white 1px, transparent 1px)', backgroundSize: '40px 40px' }}
      />

      {/* Left Side - Text Content */}
      <div className="w-full lg:w-1/2 h-full flex flex-col justify-center px-6 sm:px-12 lg:px-24 relative z-10">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          {/* Logo */}
          <h1 className="text-6xl sm:text-7xl lg:text-9xl font-bold text-foreground tracking-tighter leading-none">
            Zen<span className="text-primary text-glow">Cap</span>
          </h1>

          {/* Headline & Sub-headline */}
          <div className="space-y-2">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl text-foreground font-semibold">
              The Autonomous Financial Assistant (AFA)
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground font-light">
              Built by Xalyte Technologies
            </p>
          </div>

          {/* Tagline */}
          <p className="text-xl sm:text-2xl lg:text-3xl text-primary font-medium tracking-wide">
            Wealth Without Worry.
          </p>

          {/* Footer/Note */}
          <div className="pt-8 flex flex-col sm:flex-row gap-4 sm:gap-8 text-sm sm:text-base text-muted-foreground border-t border-border/30 mt-8">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
              <span>Raising ₹20 Lakhs</span>
            </div>
            <div className="hidden sm:block">|</div>
            <div>3-month runway</div>
            <div className="hidden sm:block">|</div>
            <div>Personal AI CFO for every Indian</div>
          </div>
        </motion.div>
      </div>

      {/* Right Side - Visual */}
      <div className="w-full lg:w-1/2 h-full relative flex items-center justify-center bg-gradient-to-br from-background via-card to-background">
        {/* Background glow effect */}
        <div className="absolute inset-0 bg-primary/5 blur-3xl" />

        {/* AI Orb Image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="relative w-[80%] max-w-[600px] aspect-square"
        >
          <img
            src="/images/slide1-adi-orb.png"
            alt="ADI AI Orb"
            className="w-full h-full object-contain animate-float"
          />
          {/* Orbital rings */}
          <div className="absolute inset-0 border border-primary/20 rounded-full scale-125 opacity-20 animate-spin-slow" />
          <div className="absolute inset-0 border border-primary/10 rounded-full scale-150 opacity-10 animate-reverse-spin" />
        </motion.div>
      </div>
    </div>
  );
};

export default Slide1Title;